const APP_BASE_PATH = "/app";
const DEFAULT_DASHBOARD_ROUTE = `${APP_BASE_PATH}/member/dashboard`;

const ROLE_ROUTE_MAP = new Map(
  [
    ["admin", `${APP_BASE_PATH}/admin/dashboard`],
    ["general manager", `${APP_BASE_PATH}/admin/dashboard`],
    ["branch manager", `${APP_BASE_PATH}/admin/dashboard`],
    ["desk officer", `${APP_BASE_PATH}/deskofficer/dashboard`],
    ["desk_officer", `${APP_BASE_PATH}/deskofficer/dashboard`],
    ["deskofficer", `${APP_BASE_PATH}/deskofficer/dashboard`],
    ["chairperson", `${APP_BASE_PATH}/chairperson/dashboard`],
    ["mwenyekiti", `${APP_BASE_PATH}/chairperson/dashboard`],
    ["katibu", `${APP_BASE_PATH}/katibu/dashboard`],
    ["secretary", `${APP_BASE_PATH}/katibu/dashboard`],
    ["accountant", `${APP_BASE_PATH}/accountant/dashboard`],
    ["muhasibu", `${APP_BASE_PATH}/accountant/dashboard`],
    ["member", `${APP_BASE_PATH}/member/dashboard`],
    ["mwanachama", `${APP_BASE_PATH}/member/dashboard`],
    ["normal member", `${APP_BASE_PATH}/member/dashboard`],
  ].map(([role, route]) => [role.toLowerCase(), route])
);

const normalizeRole = (value) =>
  typeof value === "string" ? value.trim().toLowerCase() : "";

const lookupRoute = (role) => {
  const normalized = normalizeRole(role);
  if (!normalized) {
    return null;
  }
  return ROLE_ROUTE_MAP.get(normalized) || null;
};

/**
 * Returns the dashboard route for the given user/role payload.
 * Accepts either a decoded token, a membership-like object, or a plain string role.
 */
export const getDashboardRoute = (payload, fallback = DEFAULT_DASHBOARD_ROUTE) => {
  if (!payload) {
    return fallback;
  }

  if (typeof payload === "string") {
    return lookupRoute(payload) || fallback;
  }

  const candidates = [
    payload.role,
    payload.role_name,
    payload.primary_role,
    payload.group?.name,
    payload.group?.role,
    payload.group_name,
  ];

  for (const candidate of candidates) {
    const route = lookupRoute(candidate);
    if (route) {
      return route;
    }
  }

  return fallback;
};

export default getDashboardRoute;
